import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { getScreenName, removeDefaultParams } from '../../../../Utils/helper';
import { AccordionTabs, InputField, TabList, TabsItem } from './styled';
import { fireEvent } from '../../../../Utils/fireEvent';

export default function UsefulLinks(props) {
  const { id, data, initialChecked } = props;
  const router = useRouter();
  const subCatClickHandler = (item, parent) => {
    fireEvent({
      category: 'clicked_footer_item',
      screen_name: getScreenName(),
      cta: item.name,
      parent: parent,
      deeplink_value: item?.deepLink,
    });
  };
  return (
    <AccordionTabs>
      <TabsItem>
        <InputField
          type="radio"
          id={id}
          name="check"
          defaultChecked={initialChecked}
        />
        <label className="tab-label" htmlFor={id}>
          {data?.title}
        </label>
        <div className="tab-content">
          <div>
            {data?.subCategories &&
              data?.subCategories.map((item, index) => {
                // if (index < 6) {
                if (item.proj === 'angular') {
                  return (
                    <TabList
                      onClick={() => {
                        subCatClickHandler(item, data?.title);
                      }}
                      href={item.deepLink}
                      key={`subcatfooter${index}`}
                      target="_blank"
                    >
                      {item?.name}
                    </TabList>
                  );
                } else {
                  return (
                    <Link
                      href={{
                        pathname: item?.deepLink,
                        query: removeDefaultParams(router.query),
                      }}
                      locale={false}
                      passHref
                      key={`subcatfooter${index}`}
                      prefetch={false}
                      legacyBehavior
                    >
                      <TabList
                        onClick={() => subCatClickHandler(item, data?.title)}
                        target={
                          item?.deepLinkType === 'other' ? '_blank' : undefined
                        }
                        key={`subcatfooter${index}`}
                      >
                        {item?.name}
                      </TabList>
                    </Link>
                  );
                }
                // }
              })}
          </div>
        </div>
      </TabsItem>
    </AccordionTabs>
  );
}
